import styled from 'styled-components';

const JoinUserToCoursesModalWrapper = styled.div`
  width: 400px;
`;

export default JoinUserToCoursesModalWrapper;
